<template>
  <section :class="componentClassName">
    <div class="o-lp-global-footer__container">
      <div class="o-lp-global-footer__content">
        <figure class="o-lp-global-footer__brand">
          <!-- <img src="@/images/pages/landing/ntt-com-logo.svg" alt="NTT Communications" /> -->
        </figure>
        <ul class="o-lp-global-footer__nav">
          <li class="o-lp-global-footer__nav-item">
            <a :href="helpUrl">ヘルプ</a>
          </li>
          <li class="o-lp-global-footer__nav-item">
            <a :href="privacyPolicyUrl">プライバシーポリシー</a>
          </li>
          <li class="o-lp-global-footer__nav-item">
            <a :href="termsUrl">利用規約</a>
          </li>
        </ul>
      </div>
    </div>
    <o-global-footer />
  </section>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import OGlobalFooter from '@/components/organisms/global-footer';

export default {
  name: 'o-lp-global-footer',
  components: {
    OGlobalFooter,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    helpUrl: {
      type: String,
      default: 'https://support.ntt.com/ccaas/inquiry/search',
    },
    privacyPolicyUrl: {
      type: String,
      default: 'https://www.ntt.com/about-us/hp/privacy.html',
    },
    termsUrl: {
      type: String,
      default: 'https://www.ntt.com/content/dam/nttcom/hq/jp/about-us/disclosure/tariff/pdf/c325.pdf',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-lp-global-footer');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
